const {h, render, Component} = require('preact');
const Helper = require('../../../helper')

class Banner extends Component {
  constructor(props) {
    super(props)
  }

  getBannerText() {
    return `${Groupon.Utils.getConfigFromDom().bannerText}`
  }

  decodeEntities(encodedString) {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = encodedString;
    return textArea.value;
  }


  render() {
    var bannerTextKey = this.getBannerText();
    var bannerText = I18n.translate('js.modules.shared.' + bannerTextKey)
    bannerText = this.decodeEntities(bannerText)
    if (bannerText != "$") {
        return (
            <div class="banner-web-2018 main row">
                <span class="icon-alert"></span>
                <span class="banner-text"
                      dangerouslySetInnerHTML={{__html: bannerText}}/>
            </div>
        )
    }
     else if (Helper.isFeatureFlagEnabled('showGamificationBannerWeb')) {
      return (
          <div class="gamification_banner">
          <a href="https://gr.pn/2F8wYcP" target="_blank"><img src='/customer_support/assets/1056x100_desktop-RewardGamification-190625-mb-US.jpg' alt="banner showing offers" id="web_2018-gamification-banner"
                 data-bhw="web_2018_gamification_banner" /></a>
          </div>
      )
    }
    return null
  }
}

module.exports = Banner